module.exports = __webpack_public_path__ + "434f340ba6c6bd254cb00f0dc1c5c190.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/wasistgoldencity4.jpg
// module id = 645
// module chunks = 0